import moment from "moment";

export const apiUrl = "https://haggle-it-5d9da8815d9c.herokuapp.com";
export const socketUrl = "https://haggle-it-5d9da8815d9c.herokuapp.com";

export const s3Url = "https://haggle-bucket.s3.eu-north-1.amazonaws.com";

export const imageUrl = (url) => `${s3Url}/${url}`;
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};

export const apiHeader = (token, isFormData) => {
  const headers = {
    "ngrok-skip-browser-warning": "69420",
    "timezone-offset": moment().utcOffset(),
    "Content-Type": isFormData ? "multipart/form-data" : "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return { headers };
};

export const CreateFormData = (data) => {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  return formData;
};

export const falsyArray = [
  null,
  undefined,
  "",
  0,
  false,
  Number.NaN,
  "null",
  "undefined",
  "false",
  "0",
  "NaN",
];
